import { colors, ImpHeader, ImpPad } from '@imprint-payments/imprint-ui';

import { useImpState } from '../../app/hooks';
import { getDomainFromMerchant } from '../../utils/environments';
import { isSDK } from '../../utils/sdk';
import { TrailingContent } from '../AlreadyAppliedText/AlreadyAppliedText';
import { LockupImage } from '../LockupImage/LockupImage';
import SDKHeader from '../sdk/SDKHeader';

export function HeaderHandler({
  showRewardsButton = false,
}: {
  showRewardsButton?: boolean;
}) {
  const { merchantData } = useImpState();
  const { cardName } = merchantData.rewardDetails;

  return isSDK() ? (
    <SDKHeader
      backgroundColor={colors.surface.surfaceHigh}
      isPreSubmit={showRewardsButton}
    />
  ) : (
    <ImpHeader
      leadingContent={
        <ImpPad paddingTop="m" paddingBottom="m">
          <LockupImage />
        </ImpPad>
      }
      centerText={cardName}
      trailingContent={
        <TrailingContent showRewardsButton={showRewardsButton} />
      }
      valuePropHeaderConfig={{
        cardImageSrc: merchantData.cardImg,
        valueProps: [cardName],
        onValuePropClick: () => {
          window.location.href = getDomainFromMerchant(
            merchantData.productUUID
          );
        },
      }}
    />
  );
}
